import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Esto reemplaza mi tratamiento médico?',
    a: 'No. Es un complemento espiritual y físico para mejorar tu calidad de vida diaria.'
  }, {
    q: '¿Cuánto tiempo me tomará cada mañana?',
    a: 'Menos de 5 minutos, y la mayoría se hace sin salir de la cama.'
  }, {
    q: '¿Y si fallo un día?',
    a: 'El método incluye un protocolo de Gracia de repuesto para reiniciar sin culpa.'
  }, {
    q: '¿Necesito conocimientos previos de la Biblia?',
    a: 'No, todas las herramientas y versículos vienen explicados de forma sencilla.'
  }];
  return <section className="py-12 md:py-14 px-6 bg-white" data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <FadeIn data-id="element-17">
          <h2 className="font-serif text-2xl md:text-3xl text-navy mb-6 text-center" data-id="element-18">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-3" data-id="element-19">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.08} data-id="element-20">
              <div className="p-4 rounded-xl bg-cream border border-divider/50" data-id="element-21">
                <h3 className="font-serif text-lg text-navy mb-1" data-id="element-22">{faq.q}</h3>
                <p className="text-sm text-navy/70 leading-relaxed" data-id="element-23">{faq.a}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}